import { Fragment, useEffect, useRef, useState } from "react";
import { Chart } from "chart.js";

import { PaperChartCustom } from "../../../../Theme/ContainerStyle";

export const ChartPieSmart = (props) => {
  const { datasets } = props;
  const canvas = useRef(null);
  const chartRef = useRef(null);
  const [tooltipSave, setTooltipSave] = useState()

  const chartOptions = {
    plugins: {
      legend: {display: false},
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        bodyColor: 'black',
        bodyFont: { size: 12, weight: "bold" },
        animation: false,
        callbacks: {
          label: function(tooltipItem) {
            let total = 0;
            const data = tooltipItem.dataset.data;
            data.forEach(value => {
              total += value;
            });
            const value = tooltipItem.raw;
            const valueNum = tooltipItem.raw.toFixed(1) + " Kwh";
            const percentage = ((value / total) * 100).toFixed(2);
            return `${tooltipItem.label}: ${percentage}% (${valueNum})`;
          }
        }
      },
      position: "top",
    },
  }
  
  useEffect(() => {
    const currentDataset = datasets.find(data => data.name === "currentData");

    const labels = currentDataset.dataset.map(item => {
      const labelParts = item.label.split("-");
      labelParts.pop()
      return labelParts.join("-")
    });

    const backgroundColors = currentDataset.dataset.map(item => item.backgroundColor);

    const dataValues = currentDataset.dataset.map(item => 
      item.data.reduce((acc, curr) => acc + curr, 0)
    );
    // (${value.toFixed(1)} Kwh) lo utilizzo per il valore sommato
    ///per salvarmi i valori da renderizzare il testo sotto il grafico
    const total = dataValues.reduce((acc, curr) => acc + curr, 0);
    const tooltipValues = dataValues.map((value, index) => ({
      text: `${labels[index]}: ${((value / total) * 100).toFixed(2)}% `,
      color: backgroundColors[index]
    }));

    setTooltipSave(tooltipValues)

    const data = {
      labels: labels,
      datasets: [{
        data: dataValues,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
        borderWidth: 2
      }]
    };
    if (chartRef.current) {
      chartRef.current.data = data;
      chartRef.current.update();
    } else {
      chartRef.current = new Chart(canvas.current, {
        type: 'pie',
        data: data,
        options: {
          responsive: true,
          ...chartOptions,
        }
      });
    }
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  // eslint-disable-next-line
  }, [datasets]);

  return (
    <Fragment>
      <canvas ref={canvas} />
      <PaperChartCustom className={"chart-area"}>
        {tooltipSave && tooltipSave.map((tooltip, index) => (
          <div key={index} 
            style={{ 
                textDecoration: "underline", 
                textDecorationThickness: "3px",
                textDecorationColor: tooltip.color,
                fontSize: "16px",
            }}>
            <span style={{
                  display: "inline-block",
                  width: "10px", 
                  height: "10px", 
                  backgroundColor: tooltip.color, 
                  marginRight: "5px" 
              }}/>
            {tooltip.text}
          </div>
        ))}
      </PaperChartCustom>
    </Fragment>
  );
}
